module.exports = __webpack_public_path__ + "static/dina_rajs-b01c0d7d544f53c0b7ebb6bb0d8b7cfd.jpg";